import {
  ExcelPropertyType,
  ExcelTemplate,
  MappedExcelTemplate,
} from "@src/helper/excel/excel.definition";
import { getExportTemplateFromTemplate } from "@src/helper/excel/excel.export.helper";

export const registreFormationExcelTemplate = {
  firstRowIndex: 2,
  categories: {
    assujetti: {
      columns: {
        name: {
          col: "B",
          type: ExcelPropertyType.string,
        },
        surname: {
          col: "C",
          type: ExcelPropertyType.string,
        },
        formation: {
          col: "D",
          type: ExcelPropertyType.string,
        },
      },
    },
    activite: {
      columns: {
        activite: {
          col: "E",
          type: ExcelPropertyType.string,
        },
      },
    },
    formation: {
      columns: {
        verificationDate: {
          col: "G",
          type: ExcelPropertyType.date,
        },
        hours: {
          col: "H",
          type: ExcelPropertyType.number,
        },
        theme: {
          col: "O",
          type: ExcelPropertyType.string,
        },
      },
    },
  },
} as const satisfies ExcelTemplate;

export const registreFormationExcelExportTemplate =
  getExportTemplateFromTemplate(registreFormationExcelTemplate);

export type RegistreFormationExcelTemplate =
  typeof registreFormationExcelTemplate;
export type RegistreFormationExcelMappedTemplate =
  MappedExcelTemplate<RegistreFormationExcelTemplate>;
